export default {
  CRM: 'CRM',
  SALES_HUB: 'SALES_HUB',
};
